import * as Feather from 'react-feather';

const documentHeaders = [
  {
    key: 'id',
    auxKey: 'type',
    text: 'ID',
    type: 'CHECKBOX',
    dataType: '',
    props: {}
  },
  {
    key: 'ownerName',
    text: 'Env. Para',
    type: 'DEFAULT',
    dataType: 'text',
    props: { th: { className: 'medium-col' } }
  },
  {
    key: 'name',
    text: 'Nome',
    type: 'DEFAULT',
    dataType: 'text',
    props: { th: { className: 'large-col' }, td: { className: 'big-text' } },
    icon: { condition: { column: 'type', values: { dir: Feather.Folder, doc: Feather.File } } }
  },
  {
    key: 'senderName',
    text: 'Env. Por',
    type: 'DEFAULT',
    dataType: 'text',
    props: { th: { className: 'medium-col' } }
  },
  {
    key: 'createdAt',
    text: 'Dt. Criação',
    type: 'DEFAULT',
    dataType: 'date',
    props: { th: { className: 'small-col' } }
  },
  {
    key: 'updatedAt',
    text: 'Dt. Atuali.',
    type: 'DEFAULT',
    dataType: 'date',
    props: { th: { className: 'small-col' } }
  },
];

export default documentHeaders;
